import type { ReactNode } from "react"
import { useState } from "react"

import { Button } from "@productlane/ui"

import { NavSectionHeader } from "@/components/shared/nav-section-header"

// A workspace with a few thousand articles would otherwise mount a card for
// every one of them on this screen.
export const TILES_PER_SECTION = 9

export function HomeTileSection<T>({
	label,
	items,
	renderTile,
	emptyState,
}: {
	label: string
	items: readonly T[]
	renderTile: (item: T) => ReactNode
	emptyState?: ReactNode
}) {
	const [showAll, setShowAll] = useState(false)

	// Without an empty state the section is worth nothing to an empty workspace,
	// so it stays hidden the way it always did.
	if (items.length === 0 && !emptyState) return null

	const overflowing = items.length > TILES_PER_SECTION
	const visible = showAll ? items : items.slice(0, TILES_PER_SECTION)

	return (
		<div className="mb-12">
			<NavSectionHeader label={label} className="-ml-2 mb-3" />
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
				{items.length === 0 ? emptyState : visible.map(renderTile)}
			</div>
			{overflowing && (
				<Button
					variant="outline"
					size="sm"
					className="mt-4"
					onClick={() => setShowAll((v) => !v)}
				>
					{showAll ? "Show less" : "View all"}
				</Button>
			)}
		</div>
	)
}
